// Lightweight className combiner without tailwind-merge dependency
// Minimal className combiner; avoids extra deps
export function cn(...inputs) {
  return inputs.filter(Boolean).join(" ");
}
